import React, { Component } from 'react'
import styles from './styles.scss'
import { connect } from 'react-redux'
import WebWorker from '@/workers/elementsSave.worker'
import { createEmptyObject } from '@/components/commons/editor/EditorFactory'
import { elementTypes } from '@/components/commons/editor/configs/ElementTypes'
import { MagazineProvider } from '@/contexts/magazine'
import {
  addElement,
  savePage,
  removePage,
  closeAlert,
  setHeaderMode,
  fetchPages,
  setActiveElement,
  setMagazine,
  toggleSidebar
} from '@/store/actions'
import {
  getTotalPages,
  getLastPagePosition,
  getActualPage,
  getActiveElement,
  getElements
} from '@/store/getters'
import { MagazinesResource } from '@/resources'

/** Components */
import Sidebar from './components/Sidebar'
import Pages from './components/Pages'
import PageActions from './components/PageActions'
import PageOrder from './components/PageOrder'
class MagazineComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeComponent: null,
      sideBarVisible: false,
      type: elementTypes.DEFAULT,
      itemsWorker: new WebWorker()
    }
  }

  /**
   * FETCH ALL PAGES
   */
  async componentDidMount() {
    const { id } = this.props.match.params
    if (!id) {
      return
    }

    const {
      data: magazine
    } = await MagazinesResource.getById(id)
    this.props.setMagazine(magazine)

    this.props.fetchPages(id)
    this.props.setHeaderMode('editor')

    /** inicio da gambi pra resolver problema de scroll devido a lib */

    // const cssBA = document.getElementById('css-builderall-lib')
    // const jsBA = document.getElementById('js-builderall-lib')

    // if (cssBA) cssBA.remove()
    // if (jsBA) jsBA.remove()

    /** fim da gambi pra resolver problema de scroll devido a lib */
  }

  /**
   * DESTROY THE LISTENERS
   * AND THE ACTIVE OBJECTS
   */
  componentWillUnmount() {
    this.props.setActiveElement(null)
  }

  /**
   * ADD PAGE
   */
  onAddPage() {
    const { id } = this.props.match.params
    const { lastPagePosition: position, savePage } = this.props

    savePage({
      id_magazine: id,
      page_position: position,
      properties: JSON.stringify({
        backgroundColor: '#fff'
      })
    })
  }

  /**
   * Addd a new element on the page
   * @param {ElementType} type
   */
  async onAddElement(type) {
    const { actualPage, addElement, setActiveElement, elements } = this.props
    const { id } = actualPage
    let index
    if (elements.length) {
      const _tempEl = elements[elements.length - 1]
      index = +_tempEl.position + 1
    } else {
      index = 1
    }
    const tempModel = await createEmptyObject(type, id, index)
    addElement(tempModel)
    setActiveElement({
      id: tempModel.id,
      type: type
    })
    // if (tempModel && tempModel.content.elementType !== 'text') {
    //   toggleSidebar({
    //     isOpened: false,
    //     name: null
    //   })
    // }

  }

  render() {
    const provider = {
      itemsWorker: this.state.itemsWorker,
      onAddPage: this.onAddPage.bind(this),
      onAddElement: this.onAddElement.bind(this)
    }
    const {
      actualPage
    } = this.props

    return (
      <MagazineProvider value={provider}>
        <React.Fragment>
          <section className='ba-w-100'>
            <article className='ba-flex ba-h-100 ba-w-100'>
              {actualPage && <div className={styles['magazine-content']}>
                <Pages />
                <PageActions />
                <PageOrder />
                <Sidebar />

              </div>}
            </article>
          </section>
        </React.Fragment>
      </MagazineProvider>
    )
  }
}

const mapStateToProps = state => {
  const totalPages = getTotalPages(state)
  const lastPagePosition = getLastPagePosition(state)
  const actualPage = getActualPage(state)
  const actualElement = getActiveElement(state)
  const elements = getElements(state)
  return { totalPages, lastPagePosition, actualPage, actualElement, elements }
}
export default connect(
  mapStateToProps,
  {
    addElement,
    savePage,
    removePage,
    closeAlert,
    setHeaderMode,
    fetchPages,
    setActiveElement,
    setMagazine,
    toggleSidebar
  }
)(MagazineComponent)



// WEBPACK FOOTER //
// ./src/pages/Editor/index.js